import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SvgIconName } from '../svg-icon/svg-icon-name';
import { TileButtonComponent } from '../tile-button/tile-button.component';

@Component({
  selector: 'app-tile-link',
  imports: [
    TileButtonComponent,
  ],
  templateUrl: './tile-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TileLinkComponent {
  public readonly href = input.required<string>();
  public readonly text = input.required<string>();
  public readonly icon = input<SvgIconName>();
}
